import DealerReceivePanel from "./dealerReceivePanel.container"

export default DealerReceivePanel
